import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import Avatar from './../../img/avatar-1-32.png';
import SearchIcon from './../../img/bx-search.png';
import moment from 'moment';
import 'moment-timezone';
import { SearchContact } from './SearchContact';



export class ThreadList extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            openSearchContacts: false,

            filtered: [],
            searchTerm: ""
        }

        this.toggleSearchContact = this.toggleSearchContact.bind(this);

        this.handleChange = this.handleChange.bind(this);

       /* this.hideThreadList = this.hideThreadList.bind(this);*/
    }

    toggleSearchContact() {
        this.setState({
            openSearchContacts: !this.state.openSearchContacts
        });
    }

    //hideThreadList(e) {
    //    const element = document.getElementById('thread-chat-list');
    //    element.classList.remove('show-chat-list');
    //}


    handleChange(e) {
        // Variable to hold the original version of the list
        let currentList = [];
        // Variable to hold the filtered list before putting into state
        let newList = [];

        // If the search bar isn't empty
        if (e.target.value !== "") {
            // Assign the original list to currentList
            currentList = this.props.threadList;

            // Use .filter() to determine which items should be displayed
            // based on the search terms
            newList = currentList.filter(item => {

                // change current item to lowercase
                const memberNames = item.InteractionContactNames != null ? item.InteractionContactNames.toLowerCase() : "";
                const cellphones = item.InteractionContactCellPhones != null ? item.InteractionContactCellPhones : "";
                // change search term to lowercase
                const filter = e.target.value.toLowerCase();
                // check to see if the current list item includes the search term
                // If it does, it will be added to newList. Using lowercase eliminates
                // issues with capitalization in search terms and search content
                return memberNames.includes(filter) || cellphones.includes(filter);
            });
        } else {
            // If the search bar is empty, set newList to original task list
            newList = this.props.threadList;

        }
        // Set the filtered state based on what our rules added to newList
        this.setState({
            filtered: newList,
            searchTerm: e.target.value
        });
    }


    render() {

        var list;
        if (this.state.searchTerm === "")
            list = this.props.threadList;
        else
            list = this.state.filtered;

        let scrollbarContainerHeight = '680px';
        let windowInnerHeight = window.innerHeight;

        { (!this.props.isIframe && windowInnerHeight < 890) ? scrollbarContainerHeight = '580px' : scrollbarContainerHeight = '680px'}


        return (
            <section id="thread-chat-list" className="chat-list">   {/*onClick={() => this.hideThreadList()}*/}
                <div className="chat-list-search">
                    <div className="divContactsSearchLabel">Contacts</div>
                    <div className="divInputSearch">
                        <input id="divInputControlSearch" type="text" className="form-control form-control-rounded" onChange={this.handleChange} placeholder="Search" />
                    </div>
                    <div className="div_contact_searchIcon">
                        <a className="contact_searchIcon" onClick={this.toggleSearchContact} title="Click to add a conversation ...">
                            <div className="divSearchIcon">
                                {/*<i class="bx bx-search"></i>*/}
                                <img src={SearchIcon} alt="" />
                            </div>
                        </a>
                        
                    </div>
                    <SearchContact user={this.props.user} baseApi={this.props.baseApi} isOpen={this.state.openSearchContacts} toggle={this.toggleSearchContact} addContact={this.props.addContact} createInteractionThread={this.props.createInteractionThread} />
                </div>
                <PerfectScrollbar className="chat-list-in scrollable-block" search={this.search} style={{ height: scrollbarContainerHeight }}>

                    <div className="jspContainer" >

                        {list ?
                            list.map((thread, index) => {
                                var lastInteractionDate = new Date(thread.LastInteractionOn);
                                if (lastInteractionDate.getFullYear() === 1) // the date is empty
                                    lastInteractionDate = new Date(thread.CreatedOn);
                                var today = new Date();

                                var threadTime;
                                if (lastInteractionDate.getDate() === today.getDate()) {
                                    var serverTime = moment.tz(thread.LastInteractionOn, "America/Los_Angeles");
                                    var localTimezone = moment.tz.guess();
                                    var localTime = serverTime.tz(localTimezone).format()

                                    threadTime = new Intl.DateTimeFormat('en-US', {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    }).format(new Date(localTime))

                                }
                                else
                                    threadTime =
                                        new Intl.DateTimeFormat('en-US', {
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit'
                                        }).format(lastInteractionDate)

                                return (
                                    <a key={thread.InteractionThreadID} onClick={() => this.props.chooseThread(thread.InteractionThreadID, thread)}>
                                        <div className={"chat-list-item" + (thread.InteractionThreadID == this.props.selectedInteractionThreadId ? " selected" : " notSelected")} >
                                            {/*<div className="chat-list-item-photo">*/}
                                            {/*    <img src={Avatar} alt="" />*/}
                                            {/*</div>*/}
                                            <div className="chat-list-item-avatar">
                                                <div className={"avatar mr-50" + (thread.InteractionThreadID == this.props.selectedInteractionThreadId ? " greenBgCol" : " blueBgCol")}>
                                                    {/*<span className="avatar-content">{thread ?  thread.InteractionContactNames.charAt(0).toUpperCase() : 'A'}</span>*/}
                                                </div>
                                            </div>
                                            <div className="chat-list-item-header">
                                                <div className="chat-list-item-name">
                                                    {thread.InteractionContactNames}
                                                </div>
                                            </div>
                                            <div className="chat-list-item-date">{threadTime}</div>
                                            <div className="chat-list-item-cont">{thread.InteractionContactCellPhones}
                                                <div className={thread.ReadLastMessage === false ? "chat-list-item-count " : ""}></div>
                                            </div>

                                        </div>
                                    </a>
                                )
                            }) : <div></div>}


                    </div>
                </PerfectScrollbar>
            </section>
        )
    }
}

